import OfficeEditorColumnsModal from './OfficeEditorColumnsModal';

export default OfficeEditorColumnsModal;
